import about from './about';
import aiChat from './aiChat';
import authenticationModal from './authenticationModal';
import authenticationSetup from './authenticationSetup';
import authenticationType from './authenticationType';
import breadcrumbs from './breadcrumbs';
import clients from './clients';
import common from './common';
import companyUsers from './companyUsers';
import createNewUser from './createNewUser';
import customers from './customers';
import dataSetsManagement from './dataSetsManagement';
import deactivatedUser from './deactivatedUser';
import editUserInfo from './editUserInfo';
import errors from './errors';
import home from './home';
import languages from './languages';
import launchpad from './launchpad';
import login from './login';
import materialityAssessment from './materialityAssessment';
import mfaPhoneSetup from './mfaPhoneSetup';
import multilingual from './multilingual';
import newPassword from './newPassword';
import notifications from './notifications';
import ownOperations from './ownOperations';
import permissions from './permissions';
import pillarsAndModules from './pillarsAndModules';
import products from './products';
import profile from './profile';
import profilePassword from './profilePassword';
import profileSecurity from './profileSecurity';
import profitCentres from './profitCentres';
import recoverPassword from './recoverPassword';
import recoverPasswordSuccess from './recoverPasswordSuccess';
import releaseHistory from './releaseHistory';
import standards from './standards';
import staticTranslates from './staticTranslates';
import suppliers from './suppliers';
import targetedMarketing from './targetedMarketing';
import taskManagement from './taskManagement';
import toast from './toast';
import userInfo from './userInfo';
import userManagement from './userManagement';
import valueChainMap from './valueChainMap';
import verificationCode from './verificationCode';
import verificationSms from './verificationSms';

export default {
  common,
  home,
  about,
  login,
  clients,
  languages,
  errors,
  authenticationType,
  verificationSms,
  verificationCode,
  recoverPassword,
  releaseHistory,
  recoverPasswordSuccess,
  newPassword,
  profile,
  profilePassword,
  breadcrumbs,
  launchpad,
  pillarsAndModules,
  userManagement,
  notifications,
  createNewUser,
  permissions,
  userInfo,
  companyUsers,
  authenticationSetup,
  authenticationModal,
  editUserInfo,
  deactivatedUser,
  profileSecurity,
  mfaPhoneSetup,
  dataSetsManagement,
  profitCentres,
  ownOperations,
  suppliers,
  customers,
  products,
  toast,
  multilingual,
  staticTranslates,
  valueChainMap,
  taskManagement,
  targetedMarketing,
  materialityAssessment,
  standards,
  aiChat,
};
